// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JZUgNgkrXvazeUvbxTG6{text-align:center}.Ufkf95QKX6fzzebY5qIA,.VmmKh7fuq3L7AlrifmoP{margin-bottom:2rem}.VmmKh7fuq3L7AlrifmoP{display:block;width:auto;height:5.9375rem;margin-right:auto;margin-left:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": "JZUgNgkrXvazeUvbxTG6",
	"text": "Ufkf95QKX6fzzebY5qIA",
	"img": "VmmKh7fuq3L7AlrifmoP"
};
export default ___CSS_LOADER_EXPORT___;
